import JSEncrypt from 'jsencrypt'

import { get } from "@/apis";

// 密钥对从接口 /entry/getInfo 获取，只请求一次，之后使用缓存
let keyPromise = null;

function queryEntryInfo() {
  if (!keyPromise) {
    keyPromise = get("/entry/getInfo").then((res) => {
      const { pb, pv } = res.data;
      return { pb: pb, pv: pv };
    });
    // 请求失败时清空缓存，下次调用重新获取
    keyPromise.catch(() => {
      keyPromise = null;
    });
  }
  return keyPromise;
}
// 加密
export async function encrypt(txt) {
  const { pb } = await queryEntryInfo();
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(pb) // 设置公钥
  return encryptor.encrypt(txt) // 对数据进行加密
}

// 解密
export async function decrypt(txt) {
  const { pv } = await queryEntryInfo();
  const encryptor = new JSEncrypt()
  encryptor.setPrivateKey(pv) // 设置私钥
  return encryptor.decrypt(txt) // 对数据进行解密
}

